import { api } from '../../Controllers/api'

const requestSignOnOffData = () => {
  return {
    type: 'REQUEST_SIGN_ON_OFF_DATA',
    loading: true
  }
}

const requestActiveData = () => {
  return {
    type: 'REQUEST_ACTIVE_DATA',
    loading: true
  }
}

const receiveActiveData = data => {
  return {
    type: 'RECEIVE_ACTIVE_DATA',
    payload: { activeData: data }
  }
}

const receiveUpdatedActiveData = (checkedLoads, body) => {
  return {
    type: 'RECEIVE_UPDATED_ACTIVE_DATA',
    payload: { checkedLoads, material: body.material },
    loading: false
  }
}

const receiveSignOnOffData = (data, projects, hauls, drivers) => {
  const sortedData = data.sort((a, b) => {
    if (a.haulId < b.haulId) return -1
    if (a.haulId > b.haulId) return 0
    return 0
  })
  return {
    type: 'RECEIVE_SIGN_ON_OFF_DATA',
    payload: { signOnOffData: sortedData, projects, hauls, drivers },
    loading: false
  }
}

const receiveSignOnOffDataOnly = (checkedSignOnOffs, values) => {
  return {
    type: 'RECEIVE_SIGN_ON_OFF_DATA_ONLY',
    payload: { checkedSignOnOffs, values },
    loading: false
  }
}

const receiveFilterProjects = data => {
  return dispatch =>
    dispatch({
      type: 'RECEIVE_FILTER_PROJECTS',
      payload: { projects: data }
    })
}

const receiveFilterHauls = data => {
  return dispatch =>
    dispatch({
      type: 'RECEIVE_FILTER_HAULS',
      payload: { hauls: data }
    })
}

const updateMaterial = (checkedLoads, body) => {
  return dispatch => {
    const ids = checkedLoads.toString()
    api.put(`haullog/${ids}`, body, { withCredentials: false }).then(() => {
      dispatch(receiveUpdatedActiveData(checkedLoads, body))
    })
  }
}

const updateSignOnOffTimes = (checkedSignOnOffs, values) => {
  const ids = checkedSignOnOffs.toString()
  return dispatch => {
    api
      .put(`signonoff/${ids}`, values)
      .then(() => {
        dispatch(receiveSignOnOffDataOnly(checkedSignOnOffs, values))
      })
      .catch(err => {
        alert('Unable to update sign on/off times')
      })
  }
}

const getActiveNow = isRefresh => {
  const authToken = localStorage.getItem('auth')
  return dispatch => {
    if (!isRefresh) {
      dispatch(requestSignOnOffData())
      dispatch(requestActiveData())
    }
    api
      .get(`active`)
      .then(({ data }) => {
        dispatch(receiveActiveData(data))
      })
      .then(() => {
        api
          .get(`signonoff`, {
            withCredentials: false,
            headers: { Authorization: `Bearer ${authToken}` }
          })
          .then(({ data }) => {
            let projects = data.map(item => item.projectName)
            projects = [...new Set(projects)]

            let hauls = data.map(item => item.haulId)
            hauls = [...new Set(hauls)]

            let drivers = data.map(item => item.driverId)
            drivers = [...new Set(drivers)]
            dispatch(receiveSignOnOffData(data, projects, hauls, drivers))
          })
      })
  }
}

export {
  getActiveNow,
  receiveFilterHauls,
  receiveFilterProjects,
  updateMaterial,
  updateSignOnOffTimes
}
